import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

const ease = [0.21, 0.47, 0.32, 0.98] as [number, number, number, number];

interface FadeInProps {
    children: ReactNode;
    delay?: number;
    direction?: 'up' | 'down' | 'left' | 'right' | 'none';
    className?: string;
    duration?: number;
    amount?: number;
}

const directionMap = {
    up:    { y: 40, x: 0 },
    down:  { y: -40, x: 0 },
    left:  { y: 0, x: 40 },
    right: { y: 0, x: -40 },
    none:  { y: 0, x: 0 },
};

export const FadeIn = ({
    children,
    delay = 0,
    direction = 'up',
    className,
    duration = 0.65,
    amount = 0.15,
}: FadeInProps) => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, ...directionMap[direction] }}
            whileInView={{ opacity: 1, y: 0, x: 0 }}
            viewport={{ once: true, amount }}
            transition={{ duration, delay, ease }}
        >
            {children}
        </motion.div>
    );
};

export const staggerContainer = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.1,
        },
    },
};

export const staggerItem = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease },
    },
};
